import { usePathname, useRouter, useSearchParams } from 'next/navigation';

const useMutableSearchParams = () => {
    const searchParams = useSearchParams();
    const router = useRouter();
    const pathname = usePathname()


    const setSearchParams = (name: string, value: string | undefined, mode: 'replace' | 'push' = 'push') => {
        const params = new URLSearchParams(searchParams.toString());

        const prevValue = params.get(name);
        if (prevValue === value) {
            return;
        }

        if (value === undefined) {
            params.delete(name);
        } else {
            params.set(name, value);
        }

        if (mode === 'replace') {
            router.replace(`${pathname}?${params.toString()}`);
        } else {
            router.push(`${pathname}?${params.toString()}`);
        }
    };

    return { searchParams, setSearchParams } as const;
};

export default useMutableSearchParams;
